import type { Article, CardDeck } from "../../services/educationService";

export interface DerivedPodcastMeta {
	description: string;
	bullets: string[];
	host: { name: string; role: string; initials: string; bio: string };
}

const STATIC_HOST = {
	name: "Dr. Sarah Mitchell",
	role: "Host & Reproductive Endocrinologist",
	initials: "SM",
	// Bio is rendered from the translated `podcast.hostBio` key (empty here).
	bio: "",
};

// Hebrew variant of the static demo host (same person, translated copy).
const STATIC_HOST_HE = {
	name: 'ד"ר שרה מיטשל',
	role: "מנחת הפודקאסט ורופאת פריון",
	initials: "SM",
	bio: "",
};

function initialsOf(name: string): string {
	return name
		.split(/\s+/)
		.filter(Boolean)
		.slice(0, 2)
		.map((w) => w[0])
		.join("")
		.toUpperCase();
}

/**
 * The host card comes from the article's author when the source names one
 * (e.g. a clinic team); the static demo host is only a fallback. Bios are
 * always empty here — the page renders the translated `podcast.hostBio`.
 */
export function derivePodcastMeta(
	article: Article | null,
	deck: CardDeck | null,
	locale?: string,
): DerivedPodcastMeta {
	const hebrew = !!locale && (locale === "he" || locale.startsWith("he-"));
	const author = article?.author;
	const host = author?.name
		? {
				name: author.name,
				role: author.title ?? "",
				initials: initialsOf(author.name),
				bio: "",
			}
		: hebrew
			? STATIC_HOST_HE
			: STATIC_HOST;
	return {
		description: article?.intro ?? "",
		bullets: deck?.cards.map((c) => c.question) ?? [],
		host,
	};
}
